import { Box, BoxProps, ColorOptions, Icon, Spacer, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { useNavigation } from '@react-navigation/core'
import { useEffect, useState } from 'react'
import { FlatList } from 'react-native'
import XlsxPopulate from 'xlsx-populate'
import { TextInputWithCb } from '../../components/TextInputWithCb'
import { useLazyApiData, useStores } from '../../data/store'
import { convertCamelCaseToString, isAccessible } from '../../utils'
import { MerchantForm } from './MerchantForm'

const ProcessingEntityDetails = (props: any) => {
  const { route } = props
  const { id } = route?.params ?? ''
  localStorage.setItem('params', id)
  const { accessConfig, entityData, getEntityMap } = useStores((store) => ({
    entityData: store.processingEntity.getEntity,
    getEntityMap: store.entityMaster.getEntityNameMap,
    accessConfig: store.user.getAccessConfig(['ess', 'processing_entity']),
  }))
  const [lazygetEntityMap] = useLazyApiData(getEntityMap)

  useEffect(() => {
    if (id) {
      lazygetEntityMap()
    }
  }, [id, lazygetEntityMap])

  const [isEditable, setIsEditable] = useState(false)

  const data: any = entityData(id, isEditable)

  const renderItem = ({ item }: any) => {
    return (
      <Box p={16} f={1}>
        <TextInputWithCb
          label={convertCamelCaseToString(item)}
          value={data[item] ?? ''}
          onChange={() => {}}
          showCheckbox={false}
        />
      </Box>
    )
  }

  const keyExtractor = (item: any): string => {
    return item?.id
  }

  const navigation = useNavigation()
  const handleOnUpdateSuccess = () => {
    setIsEditable(false)
    navigation.navigate('processingentity')
  }

  return (
    <Box>
      <Text
        title={'Processing Entity Mapping Detail'}
        fontSize={28}
        fontWeight={'600'}
        color={'#5a5c69' as ColorOptions}
      />
      <Box {...styles.header} bg={'#f8f9fc' as ColorOptions} paddingVertical={16} justify={'flex-end'}>
        {isAccessible(accessConfig, 'update') && (
          <Box
            flexDirection="row"
            backgroundColor={isEditable ? 'RED' : 'ORANGE'}
            padding={8}
            borderRadius={4}
            onPress={() => setIsEditable((prev) => !prev)}
            underlayColor={isEditable ? 'RED' : 'YELLOW'}>
            {!isEditable && <Icon id="EDIT" size="FONT_SIZE_LARGE" color="WHITE" />}
            {!isEditable && <Spacer direction="horizontal" size={4} />}
            <Text color="WHITE" fontFamily={'jiotype-medium'}>
              {isEditable ? 'Cancel' : 'Edit'}
            </Text>
          </Box>
        )}
      </Box>
      {!isEditable && (
        <Box {...styles.container}>
          <FlatList data={Object.keys(data)} renderItem={renderItem} numColumns={4} keyExtractor={keyExtractor} />
        </Box>
      )}
      {isEditable && (
        <MerchantForm
          id={id}
          onUpdate={handleOnUpdateSuccess}
          isEditable={isAccessible(accessConfig, 'update')}
          isDeletable={false}
        />
      )}
    </Box>
  )
}

export default ProcessingEntityDetails
const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}

const styles = {
  container: {
    ...shadow,
    borderWidth: 1,
    borderTopWidth: 0,
    borderBottomRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderColor: '#e3e6f0' as ColorOptions,
    flexDirection: 'row',
    flexWrap: 'wrap',
    p: 8,
  } as BoxProps,
  header: {
    ...shadow,
    marginTop: 16,
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 14,
    borderWidth: 1,
    borderRadius: 4,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: '#e3e6f0' as ColorOptions,
  } as BoxProps,
}
